import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { from, take } from 'rxjs';
import { RtcServiceController } from 'src/app/services/rtc.service';
import { IconTypes } from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import { ConfirmationModalComponent } from 'src/app/standalones/components/modals/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-logout-dialog',
  templateUrl:
    '../../standalones/components/modals/confirmation-modal/confirmation-modal.component.html',
  styleUrls: [
    '../../standalones/components/modals/confirmation-modal/confirmation-modal.component.scss',
  ],
})
export class LogoutDialogComponent extends ConfirmationModalComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<LogoutDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: unknown,
    private translate: TranslateService,
    private rtcControllerService: RtcServiceController,
  ) {
    const logoutModalData = {
      title: translate.instant('Sign out?'),
      cancelButtonConfig: {
        icon: '',
        iconType: IconTypes.materialIcon,
        label: translate.instant('Stay signed in'),
      },
      confirmButtonConfig: {
        icon: 'logout',
        iconType: IconTypes.materialIcon,
        label: translate.instant('Sign out'),
      },
      hasCloseButton: false,
    };

    // Call parent constructor with proper ModalData
    super(
      dialogRef as MatDialogRef<ConfirmationModalComponent>,
      null as any, // bottomSheetRef - optional parameter, can be null
      logoutModalData, // matDialogData - pass our structured data
      null as any, // matBottomSheetData - optional parameter, not used
      translate,
    );
  }

  ngOnInit(): void {
    if (this.rtcControllerService.service.isConnected()) {
      from(Promise.resolve(window.confirm(this.translate.instant('Changes not saved'))))
        .pipe(take(1))
        .subscribe((result) => {
          if (!result) {
            this.dialogRef.close(false);
          }
        });
    }
  }
}
